<template>
  <div class="page-content">
    <page-template ref="transferringTemplate"
                   :tableOptions="tableOptions"
                   :searchOptions="searchOptions"
                   :toolConfig="toolConfig"
                   :detailColumns="detailColumns"
    ></page-template>
  </div>
</template>

<script>
  import pageTemplate from '@/components/template/pageTemplate';
  import api from '@/config/api';
  import date from '@/mixin/date'

  export default {
    mixins: [date],
    components: {
      pageTemplate
    },
    data() {
      return {
        // 高级搜索条件
        searchOptions: {
          simple: [{label: '业务单号', prop: 'orderNo', type: 'input', isFuzzy: true, placeholder: '请输入业务单号'}],
          complex: [
            {
              label: '选择日期',
              prop: 'CreateDttm',
              type: 'dateTimeRangeButton',
              dateType: 'datetime',
              // defaultValue: '10',
              span: 24
            },
            // {
            //   label: '调拨级别',
            //   type: 'select',
            //   prop: 'relateType',
            //   data: this.$utils.getCacheStatus('dnRequireOrder.relateType'),
            //   span: 12,
            //   change: this.selectLevel,
            //   hidden: this.$utils.getSysUser().type === 10 ? false : true
            // },
            {
              label: '调出门店',
              type: 'select',
              prop: 'deliverStoreId',
              data: [],
              isHasAll: true,
              span: 12,
              url: api.system.seStore,
              hidden: this.$utils.getSysUser().storeId === null ? false : true
            },
            {
              label: '调入门店',
              type: 'select',
              prop: 'requireStoreId',
              data: [],
              isHasAll: true,
              span: 12,
              url: api.system.seStore
            },
            {
              label: '来源',
              prop: 'type',
              type: 'select',
              span: 12,
              data: this.$utils.getCacheStatus('dnAllocationOrder.type')
            },
            {
              label: '审核状态',
              prop: 'auditStatus',
              type: 'select',
              span: 12,
              defaultValue: 10,
              data: [{label: '未审核', value: 10}, {label: '已审核', value: 20}]
            },
            // {
            //   label: '发货状态',
            //   prop: 'shipmentStatus',
            //   type: 'select',
            //   span: 12,
            //   data: [{label: '全部', value: undefined}, {label: '未发货', value: 30}, {label: '已发货', value: 10}]
            // },
            {
              label: '收货状态',
              prop: 'receivingStatus',
              type: 'select',
              span: 12,
              data: [
                {label: '全部', value: undefined},
                {label: '未收货', value: 30},
                {label: '部分收货', value: 20},
                {label: '已收货', value: 10},
              ]
            }
          ]
        },
        // 更多功能
        toolConfig: [
          {
            label: '新增',
            code: 'insert',
            callback: this.addTransferring
          },
          {
            label: '调拨汇总',
            code: 'allotSummary',
            callback: this.allotSummary
          },
          {
            label: '编辑',
            type: this.$utils.buttonType.tableOperate,
            code: 'update',
            callback: this.toEditPage,
            filter: (data) => {
              return data.auditStatus == 10 ? true : false;
            }
          },
          {
            label: '删除',
            code: 'delete',
            type: this.$utils.buttonType.tableOperate,
            filter: (data) => {
              return data.auditStatus == 10 ? true : false;
            }
          },
          {
            label: '导出',
            code: 'export',
            callback: this.goodsDetailExport,
            filter: () => {
              return false
            }
          },
          {
            label: '退回',
            type: this.$utils.buttonType.tableOperate,
            code: 'sendBack',
            // filter: (data) => {
            //   return (data.auditStatus == 10 && data.type == 10) ? true : false;
            // }
            filter: (data) => {
              return false
            }
          },

        ],
        // 表格信息配置
        tableOptions: {
          tableName: 'clearTable',
          showSelect: true,
          indexShow: true,// 是否显示索引
          // 自定义列索引
          indexMethod: (index) => {
            return index + 1;
          },
          columns: [
            {
              label: '业务单号',
              prop: 'orderNo',
              width: '240',
              align: 'center',
              // showDetail: true
              callback: this.goOrderDetail
            },
            {
              label: '审核状态',
              prop: 'auditStatus',
              width: '100',
              align: 'center',
              enumData: this.$utils.getCacheStatus('dnAllocationOrder.auditStatus')
            },
            {
              label: '调出门店',
              prop: 'deliverStoreName',
              width: '180',
              align: 'center'
            },
            {
              label: '调入门店',
              prop: 'requireStoreName',
              width: '180',
              align: 'center'
            },
            {
              label: '单据金额(元)',
              prop: 'billAmount',
              width: '120',
              align: 'center',
              deal: this.$utils.returnFloat
            },
            {
              label: '制单人',
              prop: 'voucherName',
              width: '120',
              align: 'center'
            },
            {
              label: '制单日期',
              prop: 'voucherDttm',
              width: '150',
              align: 'center'
            },

            {
              label: '审核人',
              prop: 'deliverAuditName',
              width: '120',
              align: 'center'
            },
            {
              label: '审核日期',
              prop: 'deliverAuditDttm',
              width: '150',
              align: 'center'
            },
            // {
            //   label: '调入审核人',
            //   prop: 'requireAuditName',
            //   width: '120',
            //   align: 'center'
            // },
            // {
            //   label: '调入日期',
            //   prop: 'deliverAuditDttm',
            //   width: '150',
            //   align: 'center'
            // },
            {
              label: '要货单业务单号',
              prop: 'requireOrderNo',
              width: '240',
              align: 'center'
            },
            // {
            //   label: '来源',
            //   prop: 'type',
            //   width: '100',
            //   align: 'center',
            //   enumData: this.$utils.getCacheStatus('dnAllocationOrder.type')
            // },
            // {
            //   label: '发货状态',
            //   prop: 'shipmentStatus',
            //   width: '100',
            //   align: 'center',
            //   enumData: this.$utils.getCacheStatus('dnAllocationOrder.shipmentStatus')
            // },
            {
              label: '收货状态',
              prop: 'receivingStatus',
              width: '100',
              align: 'center',
              enumData: this.$utils.getCacheStatus('dnAllocationOrder.receivingStatus')
            },
            // {
            //   label: '是否配送',
            //   prop: 'isDistribution',
            //   width: '100',
            //   align: 'center',
            //   enumData: this.$utils.getCacheStatus('dnAllocationOrder.isDistribution')
            // },
            {
              label: '备注',
              prop: 'remarks',
              width: '150',
              align: 'center'
            }
          ],
          url: api.delivery.transferring,
          param: {auditStatus: 10, stCreateDttm: this.getStMonthDate(), edCreateDttm: this.getEdMonthDate()}
        },
        // 详情
        detailColumns: {
          statusOption: {
            prop: 'auditStatus',
            statusImg: {
              10: '/static/un-check.png',
              20: '/static/checked.png',
            },
            right: '100px',
            top: '0'
          },
          span: 8,
          labelWidth: '130',
          columns: [
            {
              label: '业务单号：',
              prop: 'orderNo',
            }, {
              label: '引用单号：',
              prop: 'requireOrderNo',
            }, {
              label: '调出门店：',
              prop: 'deliverStoreName',
            },
            {
              label: '调出仓库',
              prop: 'deliverWarehouseName',
            },
            {
              label: '调入门店：',
              prop: 'requireStoreName',
            },
            {
              label: '调入仓库',
              prop: 'requireWarehouseName',
            },
            {
              label: '经手人：',
              prop: 'handlerName',
            }, {
              label: '备注：',
              prop: 'remarks',
            }],
          tablesProp: {
            goodsMapMVOList: {
              url: api.delivery.transferringGoods + "/page",
              height: this.detailHeight,
              indexShow: true,
              showSummary: true,
              summaryColumns: ['goodsNum', 'subtotalAmount'],
              tableName: 'goodsMapMVOList',
              columns: [
                {
                  label: '条码',
                  prop: 'goodsBarCode',
                  align: 'center',
                  width: '180'
                },
                {
                  label: '商品名称',
                  prop: 'goodsName',
                  align: 'center',
                  width: '150'
                },
                {
                  label: '规格',
                  prop: 'goodsSpecs',
                  align: 'center',
                  width: '70'
                },
                {
                  label: '单位',
                  prop: 'goodsUnitName',
                  align: 'center',
                  width: '70'
                },
                {
                  label: '类别',
                  prop: 'goodsCategoryName',
                  width: '120',
                  align: "center"
                },
                {
                  label: '品牌',
                  prop: 'goodsBrandName',
                  align: 'center',
                  width: '120'
                },
                {
                  label: '配送价',
                  prop: 'deliveryPrice',
                  align: 'center',
                  width: '100'
                },
                {
                  label: '数量',
                  prop: 'goodsNum',
                  align: 'center',
                  width: '100'
                },
                {
                  label: '小计金额',
                  prop: 'subtotalAmount',
                  align: 'center',
                  width: '100'
                },
                {
                  label: '当前门店库存',
                  prop: 'goodsInventoryNum',
                  align: 'center',
                  width: '135'
                },
                {
                  label: '零售价',
                  prop: 'retailPrice',
                  align: 'center',
                  width: '100'
                },
                {
                  label: '备注',
                  prop: 'remarks',
                  align: 'center',
                  width: '150'
                }
              ]
            }
          },
          // 打印的列表
          printTablesProp: {
            goodsMapMVOList: {
              summaryColumns: ['goodsNum', 'subtotalAmount'],
              tableName: 'goodsMapMVOList',
              showSummary: true,
              columns: [
                {
                  label: '条码',
                  prop: 'goodsBarCode',
                  align: 'center',
                  width: '180'
                },
                {
                  label: '商品名称',
                  prop: 'goodsName',
                  align: 'center',
                  width: '150'
                },
                {
                  label: '规格',
                  prop: 'goodsSpecs',
                  align: 'center',
                  width: '120'
                },
                {
                  label: '单位',
                  prop: 'goodsUnitName',
                  align: 'center',
                  width: '100'
                },
                {
                  label: '类别',
                  prop: 'goodsCategoryName',
                  width: '120',
                  align: "center"
                },
                {
                  label: '品牌',
                  prop: 'goodsBrandName',
                  align: 'center',
                  width: '120'
                },
                {
                  label: '零售价',
                  prop: 'retailPrice',
                  align: 'center',
                  width: '100'
                },
                {
                  label: '配送价',
                  prop: 'deliveryPrice',
                  align: 'center',
                  width: '100'
                },
                {
                  label: '数量',
                  prop: 'goodsNum',
                  align: 'center',
                  width: '100'
                },
                {
                  label: '小计金额',
                  prop: 'subtotalAmount',
                  align: 'center',
                  width: '100'
                },
                {
                  label: '当前门店库存',
                  prop: 'goodsInventoryNum',
                  align: 'center',
                  width: '135'
                },
                {
                  label: '备注',
                  prop: 'remarks',
                  align: 'center',
                  width: '90'
                }
              ]
            },
          },
          url: api.delivery.transferringDetails
        },

      };
    },
    created() {
      this.$nextTick(() => {
        this.$refs['transferringTemplate'].operationSuccess();
      })
    },
    mounted() {
      if (Object.keys(this.$route.params).length > 0) {
        if (this.$route.params.customQuery) {
          let str = this.$route.params.customQuery
          let obj = eval('(' + str + ')')
          this.tableOptions.param = Object.assign(obj, {deliverStoreId: this.$utils.getSysUser().storeId ? this.$utils.getSysUser().storeId : -1})
        }
      }
      // this.$nextTick(() => {
      //   this.tableOptions.url = api.delivery.transferring
      //   this.$refs['transferringTemplate'].operationSuccess();
      // })
    },
    methods: {
      goOrderDetail(row) {
        this.$utils.setDataByKey(this.$utils.storeKeys.FORMINFO, this.detailColumns);
        this.$router.push({
          path: '/delivery/transferring/detail?id=' + row.id,
          query: {redirect: '/delivery/transferring'}
        }).catch(err => {
        });
      },
      addTransferring() {
        this.$router.push({path: '/delivery/transferring/add'});
      },
      allotSummary() {
        //判断是否选择数据，没有选择数据不允许跳转，选择中有已审核的数据也不允许跳转
        let selectData = this.$refs["transferringTemplate"].$refs["tableTemp"].selectRow;
        if (selectData.length === 0) {
          this.$message.warning("请至少选择一条未审核的数据");
          return;
        }
        //过滤已审核数据
        let auditData = selectData.filter(item => item.auditStatus === 20);
        if (auditData !== null && auditData.length > 0) {
          this.$message.warning("存在审核数据，不能进行汇总");
          return;
        }
        let orderNoArr = [];
        selectData.map(item => {
          orderNoArr.push(item.orderNo)
        });
        this.$router.push({path: '/delivery/transferring/summery', query: {orderNoList: orderNoArr}});
      },
      toEditPage(row) {
        this.$router.push({path: '/delivery/transferring/add?id=' + row.id + '&auditStatus=' + row.auditStatus});
      },
      selectLevel(data) {
        if (data.relateType === 10) {
          this.searchOptions.complex.filter(item => item.prop === 'deliverStoreId')[0].hidden = true;
        } else {
          this.searchOptions.complex.filter(item => item.prop === 'deliverStoreId')[0].hidden = false;
        }
      },
      goodsDetailExport() {
        let selectData = this.$refs["transferringTemplate"].$refs["tableTemp"].selectRow;
        if (selectData.length === 0) {
          this.$confirm('请选择一条数据！', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
        } else {
          if (selectData.length > 1) {
            this.$confirm('只能选择一条数据！', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$refs["transferringTemplate"].$refs["tableTemp"].$refs["clearTable"].clearSelection();
            })
          } else {
            this.$axios.fetchPost(api.delivery.transferringGoodsExport, {
              orderNo: selectData[0].orderNo,
              exportCode: 'DnAllocationGoodsExcel'
            }).then(data => {
              if (data.code === 200) {
                const elink = document.createElement('a');
                elink.href = data.data;
                elink.click();
                this.loadingExt = false;
                // this.$message({message: '导出成功', type: 'success'});
                this.$notify({
                  type: "success",
                  title: '导出操作',
                  message: '成功',
                  showClose: false,
                });
              } else {
                this.$notify({
                  type: "error",
                  title: '导出操作',
                  message: '失败',
                  showClose: false,
                });
                // this.$message({message: '导出异常', type: 'error'});
              }
            })
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/page/delivery/Transferring.vue